import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

export const Center = styled.div`
  position: relative;
`;
